<section
  class="nav-tooltip-how-it-works"
  aria-label="Opciones de venta"
  [style.--tooltip-arrow-left-how]="tooltipArrowPositionHow"
>
  <div class="nav-tooltip-how-it-works__img-col">
    <img
      src="/assets/img/prueba5.svg"
      alt="Salón de piso en venta"
      class="nav-tooltip-how-it-works__img"
    />
  </div>
  <div class="nav-tooltip-how-it-works__content">
    <div class="nav-tooltip-how-it-works__col">
      <h2 class="nav-tooltip-how-it-works__title">
        {{ "components.navTooltipHowItWorks.advisoryTitle" | translate }}
      </h2>
      <p class="nav-tooltip-how-it-works__subtitle">
        {{ "components.navTooltipHowItWorks.advisorySubtitle" | translate }}
      </p>
      <ul class="nav-tooltip-how-it-works__list">
        <li class="nav-tooltip-how-it-works__item">
          <img
            src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/bar-chart.svg"
            alt="{{
              'components.navTooltipHowItWorks.advisoryList.strategicPlanning'
                | translate
            }}"
          />
          {{
            "components.navTooltipHowItWorks.advisoryList.strategicPlanning"
              | translate
          }}
        </li>
        <li class="nav-tooltip-how-it-works__item">
          <img
            src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/strategy.svg"
            alt="{{
              'components.navTooltipHowItWorks.advisoryList.exclusiveOpportunities'
                | translate
            }}"
          />
          {{
            "components.navTooltipHowItWorks.advisoryList.exclusiveOpportunities"
              | translate
          }}
        </li>
        <li class="nav-tooltip-how-it-works__item">
          <img
            src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/handshake.svg"
            alt="{{
              'components.navTooltipHowItWorks.advisoryList.purchaseSupport'
                | translate
            }}"
          />
          {{
            "components.navTooltipHowItWorks.advisoryList.purchaseSupport"
              | translate
          }}
        </li>
        <li class="nav-tooltip-how-it-works__item">
          <img
            src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/line-hart.svg"
            alt="{{
              'components.navTooltipHowItWorks.advisoryList.taxOptimization'
                | translate
            }}"
          />
          {{
            "components.navTooltipHowItWorks.advisoryList.taxOptimization"
              | translate
          }}
        </li>
      </ul>
      <button class="yellow-btn" (click)="goNavigateToUrlService('consulting')">
        <span>{{
          "components.navTooltipHowItWorks.advisoryButton" | translate
        }}</span>
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>
    <hr class="nav-tooltip-how-it-works__divider" />
    <div class="nav-tooltip-how-it-works__col">
      <h2 class="nav-tooltip-how-it-works__title">
        {{ "components.navTooltipHowItWorks.servicesTitle" | translate }}
      </h2>
      <p class="nav-tooltip-how-it-works__subtitle">
        {{ "components.navTooltipHowItWorks.servicesSubtitle" | translate }}
      </p>
      <ul class="nav-tooltip-how-it-works__list">
        <li class="nav-tooltip-how-it-works__item">
          <img
            src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/verified-user.svg"
            alt="{{
              'components.navTooltipHowItWorks.servicesList.legalAdvice'
                | translate
            }}"
            loading="lazy"
          />
          {{
            "components.navTooltipHowItWorks.servicesList.legalAdvice"
              | translate
          }}
        </li>
        <li class="nav-tooltip-how-it-works__item">
          <img
            src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/hand-with-coins.svg"
            alt="{{
              'components.navTooltipHowItWorks.servicesList.financing'
                | translate
            }}"
            loading="lazy"
          />
          {{
            "components.navTooltipHowItWorks.servicesList.financing" | translate
          }}
        </li>
        <li class="nav-tooltip-how-it-works__item">
          <img
            src="../../../../assets/icons/tool.svg"
            alt="{{
              'components.navTooltipHowItWorks.servicesList.insurance'
                | translate
            }}"
            loading="lazy"
          />
          {{
            "components.navTooltipHowItWorks.servicesList.insurance" | translate
          }}
        </li>
        <li class="nav-tooltip-how-it-works__item">
          <img
            src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/shield-check.svg"
            alt="{{
              'components.navTooltipHowItWorks.servicesList.rentalManagement'
                | translate
            }}"
            loading="lazy"
          />
          {{
            "components.navTooltipHowItWorks.servicesList.rentalManagement"
              | translate
          }}
        </li>
      </ul>
      <button class="green-btn" (click)="goNavigateToUrlService('services')">
        <span>{{
          "components.navTooltipHowItWorks.servicesButton" | translate
        }}</span>
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>
  </div>
</section>
